import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { fetchReset } from '../actions/fetch.actions';
import { MODALS } from '../constants/modals.constants';
import { attachmentBody } from '../lib/dossier.utils';
import { DOSSIER_ACTIVITY_RESOURCE } from '../resources/dossier.activity.resource';
import { DOSSIER_ATTACHMENTS_RESOURCE } from '../resources/dossier.attachments.resource';
import { attachments } from '../services/bff.api';
import responseValidators from '../services/response.validators';
import { useForm } from './useForm.hook';
import { useModal } from './useModal.hook';

export const useAttachmentCRUD = (dossierId) => {
  const dispatch = useDispatch();
  const uploadModal = useModal(MODALS.ATTACHMENT_UPLOAD);
  const detailsModal = useModal(MODALS.ATTACHMENT_DETAILS);
  const deleteModal = useModal(MODALS.ATTACHMENT_CONFIRM_DELETE);
  const attachmentDetailForm = useForm(MODALS.ATTACHMENT_DETAILS.initialState);
  const [openedAttachmentReferenceId, setOpenedAttachmentReferenceId] = useState('');
  const [openedAttachmentType, setOpenedAttachmentType] = useState('');

  const onAttachmentsRefetch = () => {
    dispatch(fetchReset(DOSSIER_ATTACHMENTS_RESOURCE));
    dispatch(fetchReset(DOSSIER_ACTIVITY_RESOURCE));
  };

  const onAttachmentAddOpen = (referenceId, type) => {
    setOpenedAttachmentReferenceId(referenceId);
    setOpenedAttachmentType(type);
    uploadModal.onOpen();
  };

  const onAttachmentAdd = (data, options) =>
    attachments
      .uploadForDossier(dossierId, attachmentBody(openedAttachmentReferenceId, openedAttachmentType, data))
      .then((resp) => {
        if (options?.onSuccess) {
          options.onSuccess(resp.json);
        }
        onAttachmentsRefetch();
        return resp;
      })
      .catch((err) => {
        if (options?.onError) {
          options.onError(err.message);
        }
      });

  const onAttachmentUpdate = (attachmentId, data) => attachments.updateForDossier(dossierId, attachmentId, data);

  const onAttachmentOpen = (attachment) => {
    attachmentDetailForm.load(attachment);
    setOpenedAttachmentType(attachment?.type);
    detailsModal.onOpen();
  };

  const onAttachmentDelete = (onError, onSuccess) => {
    attachments
      .deleteForDossier(dossierId, attachmentDetailForm?.data?.id)
      .then((resp) => {
        responseValidators.deleteForDossier(resp);
        onAttachmentsRefetch();
        onSuccess();
        detailsModal.onClose();
      })
      .catch((err) => {
        onError(err.message);
      });
  };

  return {
    uploadModal,
    detailsModal,
    deleteModal,
    attachmentDetailForm,
    openedAttachmentType,
    onAttachmentAddOpen,
    onAttachmentAdd,
    onAttachmentUpdate,
    onAttachmentOpen,
    onAttachmentDelete,
    onAttachmentsRefetch
  };
};
